<template>
  <div>
    <BaseParagraph class="mb-2">{{ hint }}</BaseParagraph>
    <div class="mb-10">
      <BaseSelect
        v-for="i in 3"
        :key="i"
        :label="$t('Choice number', { i })"
        :options="itemsFor(i)"
        :value="itemFor(i)"
        track-by="value"
        select-label="label"
        class="mb-4"
        @input="update(i, $event.value)"
      />
    </div>
  </div>
</template>

<script>
import { clone, find, pull, includes } from 'lodash';
import BaseParagraph from './BaseParagraph.vue';
import BaseSelect from './BaseSelect.vue';

export default {
  name: 'BaseTop3',
  components: {
    BaseParagraph,
    BaseSelect,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    value: {
      type: Array,
      default: null,
    },
    hint: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      duplicateItems: [[], [], []],
    };
  },
  watch: {
    value() {
      this.initDuplicates();
    },
  },
  mounted() {
    this.initDuplicates();
  },
  methods: {
    initDuplicates() {
      this.duplicateItems = [1, 2, 3].map(this.duplicate);
    },
    update(i, value) {
      if (!value) {
        return;
      }
      let newValue = [];
      if (this.value) {
        newValue = clone(this.value);
      }
      pull(newValue, value);
      newValue[i - 1] = value;
      this.$emit('input', newValue);
    },
    itemFor(i) {
      if (this.value) {
        const currentValue = this.value[i - 1];
        if (currentValue) {
          const item = find(this.items, { value: currentValue });
          if (item) {
            return item;
          }
        }
      }
      return null;
    },
    duplicate(i) {
      return this.items.map((item) => {
        const newItem = Object.assign({}, item);
        if (this.value &&
            newItem.value !== this.value[i - 1] &&
            includes(this.value, newItem.value)) {
          newItem.$isDisabled = true;
        }
        return newItem;
      });
    },
    itemsFor(i) {
      return this.duplicateItems[i - 1];
    },
  },
};
</script>
